import React from 'react'
import { Button, Typography } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import { FormattedMessage, useIntl } from 'react-intl'
import { useStyles } from './Styles'
import moment from 'moment'

const GeneralTableWithFilter = ({
  handleListingFilterSubmit, noFilter, listingData, listingPage, columns, submitFilterRef,
  listingCount, listingRowsPerPage, handleChangeListingPage, handleChangeListingRowsPerPage,
  noPagination, titleKey, type
}) => {
  const classes = useStyles()
  const intl = useIntl()
  const [newColumns, setNewColumns] = React.useState(columns)
  const [columnsDisplay, setColumnsDisplay] = React.useState([])

  React.useEffect(() => {
    if (!!columnsDisplay?.length) {
      setNewColumns(columns.map((col, index) => {
        if (!col.options.viewColumns) {
          col.options.display = columnsDisplay[index]
        }
        return col
      }))
    }
    // eslint-disable-next-line
  }, [columns, columnsDisplay])

  React.useEffect(() => {
    setColumnsDisplay(columns.map(col => col.options.hasOwnProperty('display') ? col.options.display : 'true'))
    // eslint-disable-next-line
  }, [])

  const handleChangeColumnDisplay = (columnName, display) => {
    let colIndex = columns.map(column => column.name).indexOf(columnName)
    let updatedColumns = [...columnsDisplay]
    updatedColumns[colIndex] = display
    setColumnsDisplay(updatedColumns)
  }

  const listKeys = []
  const boolKeys = ['Active']
  const dateTimeKeys = ['DateFrom', 'DateTo']
  const dateStartKeys = ['ActiveFrom']
  const dateEndKeys = ['ActiveTo']

  const changeFilter = (applyFilters) => {
    let filterList = applyFilters()
    let allFiltersData = {}
    let filters = {}
    if (!!filterList.length) {
      filterList.forEach((filterItem, index) => {
        allFiltersData[columns[index].key_name] = filterItem
        if (!!filterItem.length) {
          if (listKeys.includes(columns[index].key_name)) {
            filters[columns[index].key_name] = filterItem
          } else if (boolKeys.includes(columns[index].key_name)) {
            filters[columns[index].key_name] = !!filterItem[0] ? true : false
          } else if (dateTimeKeys.includes(columns[index].key_name)) {
            filters[columns[index].key_name] = filterItem[0] ? moment(filterItem[0]).locale('en-us').format('YYYY-MM-DD hh:mm A') : ''
          } else if (dateStartKeys.includes(columns[index].key_name)) {
            filters[columns[index].key_name] = filterItem[0] ? moment(filterItem[0]).locale('en-us').startOf('day').utc().format() : ''
          } else if (dateEndKeys.includes(columns[index].key_name)) {
            filters[columns[index].key_name] = filterItem[0] ? moment(filterItem[0]).locale('en-us').endOf('day').utc().format() : ''
          } else if (!!filterItem[0] && filterItem[0]?.toString().length >= 1) {
            filters[columns[index].key_name] = filterItem[0]
          }
        }
      })
    }
    handleListingFilterSubmit(filters, null, true)
  }
  const options = {
    filter: !noFilter,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: listingCount,
    search: false,
    pagination: !noPagination,
    jumpToPage: !noPagination,
    rowsPerPage: listingRowsPerPage,
    rowsPerPageOptions: [10, 25, 50, 100, 200],
    onChangePage: handleChangeListingPage,
    onChangeRowsPerPage: handleChangeListingRowsPerPage,
    page: listingPage > -1 ? listingPage : 0,
    confirmFilters: true,
    fixedHeader: true,
    fixedSelectColumn: true,
    print: false,
    download: false,
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button color='primary' ref={submitFilterRef}
            variant="contained" onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Requests.List.Table.ApplyFilters' /></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip' ||
        (typeof column === 'string' && typeof type === 'string' && type === 'custom'
          && columns.map(item => item.name)?.includes(column))) {
        if (columns.filter(item => item.name === column && !!item.isCustomTextFieldFilter)?.length) {
          let stateIndex = columns.map(column => column.name).indexOf(column)
          if (stateIndex > -1 && filterList.length) {
            filterList[stateIndex] = []
          }
        }
        let newFilters = () => (filterList)
        changeFilter(newFilters)
      }
    },
    onViewColumnsChange: (changedColumn, action) => {
      handleChangeColumnDisplay(changedColumn, action.toString() === 'add' ? 'true' : 'false')
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: `${type || 'Invoices'}.List.Table.NoMatching` }),
        toolTip: intl.formatMessage({ id: 'Table.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Table.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Table.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Table.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Table.List.Table.RowsPerPage' }),
        jumpToPage: intl.formatMessage({ id: 'Table.List.Table.jumpToPage' }),
        displayRows: intl.formatMessage({ id: 'Table.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Table.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'Table.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Table.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Table.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Table.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Table.List.Table.All' }),
        title: intl.formatMessage({ id: 'Table.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Table.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Table.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Table.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      // if ('changePage' === action) {
      //   changePage(tableState.page, tableState.sortOrder)
      // }
      // switch (action) {
      //   // case 'changePage':
      //   //   changePage(tableState.page, tableState.sortOrder)
      //   //   break
      //   case 'sort':
      //     sortListingData(tableState.sortOrder)
      //     break
      //   default:
      //     break
      // }
    }
  }
  return (
    <MUIDataTable
      title={
        <Typography variant="h5">
          <FormattedMessage id={titleKey} />
        </Typography>
      }
      data={listingData}
      columns={newColumns}
      options={options}
    />
  )
}

export default GeneralTableWithFilter
